import type { ApiResponse, UseApiClientReturn } from "@Front/Hooks/useApiClientTypes";
import { useApiCrudVerbs } from "@Front/Hooks/useApiCrudVerbs";
import { useApiSendRequest } from "@Front/Hooks/useApiSendRequest";

type ExecuteRequestFn = <T = unknown>(params: {
	url: string;
	init: RequestInit;
	method: string;
	endpoint: string;
	errorMessage?: string;
	logErrors?: boolean;
	background?: boolean;
}) => Promise<ApiResponse<T>>;

export function useApiSendAndCrud(
	baseUrl: string,
	getAccessToken: (endpoint?: string) => string | null,
	getHeaders: (requireAuth?: boolean, additionalHeaders?: HeadersInit, endpoint?: string) => Headers,
	executeRequest: ExecuteRequestFn,
): Pick<UseApiClientReturn, "get" | "post" | "put" | "delete"> {
	const sendRequest = useApiSendRequest(baseUrl, getAccessToken, getHeaders, executeRequest);
	return useApiCrudVerbs(sendRequest);
}
